import { motion } from "framer-motion";

const placards = [
  {
    n: "I.",
    title: "Governance beyond compliance",
    body:
      "Two decades of stage-gate discipline, KPI-based reporting and monthly board MIS — I read the numbers before they read me.",
  },
  {
    n: "II.",
    title: "CAPEX with a fiduciary lens",
    body:
      "Direct oversight of programs valued ₹1,800 – ₹2,300 Cr each; cumulative CAPEX exposure exceeding ₹3,200 Cr governed to plan.",
  },
  {
    n: "III.",
    title: "Risk, resolved on the plan",
    body:
      "Critical-chain and constraint-management practice that has recovered 26- and 36-day schedule delays without margin erosion.",
  },
  {
    n: "IV.",
    title: "An independent voice",
    body:
      "No promoter overhang. No vendor overhang. A career built in four industrial groups — I ask the questions the room forgets to.",
  },
  {
    n: "V.",
    title: "HSE, QA/QC & statutory readiness",
    body:
      "PSSR, RTO and commissioning-readiness are habits, not exceptions. The board should never be surprised at handover.",
  },
  {
    n: "VI.",
    title: "A fluency in both futures",
    body:
      "Traditional heavy industry and emerging categories — EV design (IIT Roorkee), Cybersecurity (ISC2), and Generative AI (Oracle).",
  },
];

const cardVariant = {
  hidden: { opacity: 0, y: 60 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.9, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] },
  }),
};

export default function WhyBoards() {
  return (
    <section id="why-boards" className="relative border-b border-surface-2 bg-[#0b1a30]">
      <div className="mx-auto max-w-[1440px] px-6 md:px-16 py-28 md:py-40">
        <div className="grid grid-cols-12 gap-6 items-end">
          <div className="col-span-12 md:col-span-4">
            <div className="text-[11px] uppercase tracking-[0.28em] text-brass">
              <span className="tabular">03 —</span>
              <span className="ml-3">The Answer</span>
            </div>
            <h2 className="mt-4 font-serif-display font-light text-ivory text-5xl md:text-6xl leading-[0.95] tracking-[-0.02em]">
              Why boards<br /> should<br /> <span className="italic text-brass">select me</span>.
            </h2>
          </div>
          <div className="col-span-12 md:col-span-7 md:col-start-6">
            <p className="text-mutedfg text-lg leading-relaxed font-light max-w-lg">
              Six placards. Six reasons. Written for the chair, the audit committee and the shareholder
              who wants project realism at the board table — not project optimism.
            </p>
          </div>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-surface-2">
          {placards.map((p, i) => (
            <motion.div
              key={p.n}
              custom={i}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, margin: "-60px" }}
              variants={cardVariant}
              className="placard bg-ink p-10 md:p-12 border border-transparent min-h-[300px] flex flex-col"
              data-testid={`placard-${i}`}
            >
              <div className="flex items-center justify-between mb-8">
                <span className="font-serif-display text-brass text-2xl italic">{p.n}</span>
                <span className="h-px w-16 bg-brass/50" />
              </div>
              <h3 className="font-serif-display text-ivory text-2xl md:text-3xl font-light leading-tight">
                {p.title}
              </h3>
              <p className="mt-6 text-mutedfg leading-relaxed font-light">{p.body}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
